module.exports = __webpack_public_path__ + "img/marico.d09b6746.png";